// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import extend from 'lodash/extend';
// ANTD
import Form from 'antd/lib/form';
import Button from 'components/common/Button';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Input from 'antd/lib/input';
import DatePicker from 'antd/lib/date-picker';
import TimePicker from 'antd/lib/time-picker';
// MODULES
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
// import SessionCategoryInput from 'components/input/SessionCategoryInput';
import ClientInput from 'components/inputs/ClientInputLegacy';

const FormItem = Form.Item;
const { TextArea } = Input;

// This component only renders the Session form, all the logic must be handled
// in the parent component.
class SessionForm extends React.Component {
  formatDate = date => moment
    .utc(date)
    .startOf('day')
    .toISOString();

  onSuccessfullyValidated = session => {
    const { onSubmitHook } = this.props;

    // Format session date
    if (session && session.sessionDate) {
      const date = this.formatDate(session.sessionDate);
      extend(session, { sessionDate: date });
    }
    // Format session time from date to string
    if (session && session.sessionTime) {
      const hm = session.sessionTime.format('h:mm a');
      extend(session, { sessionTime: hm });
    }

    // Pass lineItem values to parent component to handle submit functionality
    onSubmitHook(session, this.props.form);
  };

  handleSubmit = evt => {
    const { onBeforeHook, onErrorHook, form } = this.props;

    evt.preventDefault();

    // Run before logic if provided and return on error
    try {
      onBeforeHook();
    } catch (exc) {
      return; // return silently
    }

    form.validateFields((err, session) => {
      if (err) {
        // Pass event up to parent component
        onErrorHook(err);
      } else {
        return this.onSuccessfullyValidated(session);
      }
    });
  };

  getFormConfigs = () => {
    const { initialValue } = this.props;

    const titleConfig = {
      initialValue: (initialValue && initialValue.title) || null,
      validateTrigger: 'onBlur',
      rules: [
        { required: true, message: 'Please input a Title!' },
        { max: 70, message: 'Must be no more than 70 characters!' },
      ],
    };

    const descriptionConfig = {
      initialValue: (initialValue && initialValue.description) || null,
      validateTrigger: 'onBlur',
      rules: [
        { required: false, message: 'Please input a description!' },
        { max: 7500, message: 'Must be no more than 7500 characters!' },
      ],
    };

    const sessionDateConfig = {
      initialValue:
        (initialValue && initialValue.sessionDate && GeneralHelpers.formatDatePickerTime(initialValue.sessionDate))
        || null,
      validateTrigger: 'onChange',
      rules: [{ required: true, message: 'Please input a date!' }],
    };

    const sessionTimeConfig = {
      initialValue: (initialValue && initialValue.sessionTime && moment(initialValue.sessionTime, 'h:mm a')) || null,
      validateTrigger: 'onBlur',
      rules: [],
    };

    return {
      titleConfig,
      descriptionConfig,
      sessionDateConfig,
      sessionTimeConfig,
    };
  };

  resetFields = () => {
    this.props.form.resetFields();
  };

  render() {
    const {
      form, btnLabel, initialValue, disabled, hideClientInput,
    } = this.props;
    const { getFieldDecorator } = form;
    const {
      titleConfig, descriptionConfig, sessionDateConfig, sessionTimeConfig,
    } = this.getFormConfigs();

    return (
      <div className="form-container" style={{ minHeight: '380px', maxWidth: '400px', margin: 'auto' }}>
        <Form onSubmit={this.handleSubmit} style={{ width: '100%' }}>
          <Row gutter={15} justify="flex-start">
            <Col xs={24}>
              <FormItem label="Title" hasFeedback>
                {getFieldDecorator('title', titleConfig)(<Input size="large" placeholder="title..." />)}
              </FormItem>
            </Col>
            <Col xs={24}>
              <FormItem label="Notes" hasFeedback>
                {getFieldDecorator('description', descriptionConfig)(<TextArea size="large" rows={5} />)}
              </FormItem>
            </Col>
            <Col xs={24}>
              <FormItem label="Session Date" hasFeedback>
                {getFieldDecorator('sessionDate', sessionDateConfig)(<DatePicker size="large" rows={5} />)}
              </FormItem>
            </Col>
            <Col xs={24}>
              <FormItem label="Session Time" hasFeedback>
                {getFieldDecorator('sessionTime', sessionTimeConfig)(
                  <TimePicker size="large" use12Hours format="h:mm a" />,
                )}
              </FormItem>
            </Col>
            {/* <Col xs={12}>
              <SessionCategoryInput
                {...this.props}
                sessionTypes={this.props.sessionTypes}
                initialValue={(initialValue && initialValue.category) || null}
                form={form}
              />
                </Col> */}
            <Col xs={12} className={hideClientInput ? 'display-none' : ''}>
              <ClientInput
                required={false}
                initialValue={(initialValue && initialValue.client && initialValue.client._id) || null}
                form={form}
              />
            </Col>
          </Row>
          <Button
            htmlType="submit"
            type="primary"
            disabled={disabled}
            loading={disabled}
            size="large"
            style={{ marginLeft: 8 }}
          >
            {btnLabel}
          </Button>
        </Form>
      </div>
    );
  }
}

SessionForm.propTypes = {
  btnLabel: PropTypes.string,
  initialValue: PropTypes.shape({
    title: PropTypes.string,
    amount: PropTypes.string,
    description: PropTypes.string,
    sessionDate: PropTypes.String,
    sessionTime: PropTypes.String,
    category: PropTypes.string,
    client: PropTypes.object,
  }),
  disabled: PropTypes.bool,
  hideClientInput: PropTypes.bool,
  onBeforeHook: PropTypes.func,
  onErrorHook: PropTypes.func,
  onSubmitHook: PropTypes.func,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func.isRequired,
  }).isRequired,
};

SessionForm.defaultProps = {
  btnLabel: 'SUBMIT',
  initialValue: null,
  disabled: false,
  hideClientInput: false,
  onBeforeHook: () => {},
  onErrorHook: () => {},
  onSubmitHook: () => {},
};

export default Form.create()(SessionForm);



// WEBPACK FOOTER //
// ./src/components/forms/SessionFormLegacy/index.js